// extracted by mini-css-extract-plugin
module.exports = {"contract":"Contract_contract__3Ycmi","contractBlock":"Contract_contractBlock__1P1A-"};